import * as React from 'react';

import { useIsMobileDevice } from '../../../../hooks';

import { AboutBlock } from '../AboutBlock';

import * as styles from './styles.css';

export const CommercialOwnerWidgetLayout: React.FC = ({ children }) => {
  const isMobile = useIsMobileDevice();

  return (
    <>
      <AboutBlock className={styles['about-block']} isMobile={isMobile} />
      <div className={styles['main-form']}>{children}</div>
    </>
  );
};

CommercialOwnerWidgetLayout.displayName = 'CommercialOwnerWidgetLayout';
